/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import {
  BusinessNumberType,
  ContactDeliveryMethod,
  CreditorType,
  EmailMatch,
  SupplierCategoryType,
  WithholdingTaxType,
} from '@gh/builder-shared-data';
import { ContextRoute, getContextRouteInitData } from '@gh/common-internal-shared';
import { EnumDictionary, IS_REGION_AU, IS_REGION_NZ, IS_REGION_US } from '@gh/common-shared';
import { assign } from 'lodash';
import { ContactDetailsCreditorFormState } from '../contact-details-creditor-tab/contact-details-creditor-form.service';
import { ContactDetailsCreditorCommonFormState } from './contact-details-creditor-common-form.service';
import { Validators } from '@angular/forms';

@Component({
  selector: 'gh-contact-details-creditor-common-tab',
  template: require('./contact-details-creditor-common-tab.component.html'),
  styles: [require('./contact-details-creditor-common-tab.component.scss')],
})
export class ContactDetailsCreditorCommonTabComponent implements OnInit {
  creditorTypes: EnumDictionary<CreditorType>;
  deliveryMethods: EnumDictionary<ContactDeliveryMethod>;
  emailMatches: EnumDictionary<EmailMatch>;
  supplierCategories: EnumDictionary<SupplierCategoryType>;
  businessNumberTypes: EnumDictionary<BusinessNumberType>;
  whtTaxTypes: EnumDictionary<WithholdingTaxType>;

  get auRegion(): boolean {
    return IS_REGION_AU;
  }

  get usRegion(): boolean {
    return IS_REGION_US;
  }

  get nzRegion(): boolean {
    return IS_REGION_NZ;
  }

  get whtExemption(): boolean {
    return this.form.whtExemption;
  }

  get isActivityVisibleAndRequiredNz(): boolean {
    return this.nzRegion && this.form.group.value.businessInfo.type !== WithholdingTaxType.NotWhtLiable;
  }

  constructor(private route: ContextRoute,
              public creditorForm: ContactDetailsCreditorFormState,
              public form: ContactDetailsCreditorCommonFormState) {
  }

  ngOnInit(): void {
    assign(this, getContextRouteInitData(this.route));
    this.setActivityRequired();
  }

  onTypeAssign(): void {
    this.creditorForm.updateSubContractorForm();
  }

  onNumberTypeChange(): void {
    this.form.updateBusinessInfo();
  }

  onWithholdingTypeChange(): void {
    this.form.updateBusinessInfo();
    this.setActivityRequired();
  }

  setActivityRequired(): void {
    if (this.isActivityVisibleAndRequiredNz) {
      this.form.group.get('businessInfo.activity')?.setValidators(Validators.required);
    } else {
      this.form.group.get('businessInfo.activity')?.clearValidators();
      this.form.group.get('businessInfo.activity')?.reset();
    }
  }
}
